/** A preference for future reports, not permission to enable analysis or notification services. */
export interface MarketNotificationConfig {
    schema_version: 'market-notification-config/v1';
    report_ready: boolean;
}

export function normalizeNotificationConfig(value: unknown): MarketNotificationConfig {
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Invalid report notification configuration');
    const input = value as Record<string, unknown>;
    if (Object.keys(input).length !== 2 || input.schema_version !== 'market-notification-config/v1'
        || typeof input.report_ready !== 'boolean') throw new Error('Invalid report notification configuration');
    return { schema_version: 'market-notification-config/v1', report_ready: input.report_ready };
}

export function notificationConfigWrite(reportReady: boolean | undefined): MarketNotificationConfig | undefined {
    return reportReady === undefined ? undefined : normalizeNotificationConfig({ schema_version: 'market-notification-config/v1', report_ready: reportReady });
}

export function validNotificationConfig(value: unknown): boolean {
    if (value === undefined) return true;
    try { normalizeNotificationConfig(value); return true; } catch { return false; }
}

export function notificationConfigMatches(requested: unknown, echoed: unknown): boolean {
    if (requested === undefined) return true; // Old editors do not replace saved preferences.
    try { return normalizeNotificationConfig(requested).report_ready === normalizeNotificationConfig(echoed).report_ready; }
    catch { return false; }
}
